export default "__VITE_ASSET__DH$qMxME__"